import { Divider } from '@mui/material';

export default function RouteAnalysisModal(props) {
  const { routeObjs, handleSubmit } = props;

  return (
    <>
      <div
        style={{
          width: '100%',
          padding: 12,
          background: 'white',
          borderBottom: '1px #D9D9D9 solid',
          justifyContent: 'space-between',
          alignItems: 'center',
          display: 'inline-flex',
        }}
      >
        <div
          style={{
            flex: '1 1 0',
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column',
            color: '#3A474F',
            fontSize: 16,
            fontFamily: 'Poppins',
            fontWeight: '500',
            wordWrap: 'break-word',
            textAlign: 'left',
          }}
        >
          Routes Analysis{' '}
        </div>
        <div
          style={{ justifyContent: 'flex-start', alignItems: 'center', gap: 12, display: 'flex' }}
        >
          <div
            style={{
              padding: 6,
              background: 'white',
              boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
              overflow: 'hidden',
              borderRadius: 4,
              outline: '1px rgba(42, 54, 71, 0.08) solid',
              outlineOffset: '-1px',
              justifyContent: 'flex-start',
              alignItems: 'center',
              gap: 12,
              display: 'flex',
            }}
          >
            <div style={{ width: 20.31, height: 20.31, background: 'black' }} />
          </div>
          <div
            style={{
              paddingLeft: 12,
              paddingRight: 12,
              paddingTop: 6,
              paddingBottom: 6,
              background: 'white',
              boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
              overflow: 'hidden',
              borderRadius: 4,
              outline: '1px rgba(42, 54, 71, 0.08) solid',
              outlineOffset: '-1px',
              justifyContent: 'flex-start',
              alignItems: 'center',
              gap: 12,
              display: 'flex',
            }}
          >
            <div style={{ width: 12, height: 12, background: '#2B323B' }} />
            <div
              style={{
                color: '#2B323B',
                fontSize: 16,
                fontFamily: 'Inter',
                fontWeight: '400',
                wordWrap: 'break-word',
              }}
            >
              Filter
            </div>
          </div>
          <div
            style={{
              paddingLeft: 12,
              paddingRight: 12,
              paddingTop: 6,
              paddingBottom: 6,
              background: 'white',
              boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
              overflow: 'hidden',
              borderRadius: 4,
              outline: '1px rgba(42, 54, 71, 0.08) solid',
              outlineOffset: '-1px',
              justifyContent: 'flex-start',
              alignItems: 'center',
              gap: 12,
              display: 'flex',
            }}
          >
            <div
              style={{
                color: '#2B323B',
                fontSize: 16,
                fontFamily: 'Inter',
                fontWeight: '400',
                wordWrap: 'break-word',
              }}
            >
              Sort by
            </div>
            <div style={{ width: 12, height: 7.33, background: '#2B323B' }} />
          </div>
          <div
            style={{
              paddingLeft: 12,
              paddingRight: 12,
              paddingTop: 6,
              paddingBottom: 6,
              background: 'white',
              boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
              overflow: 'hidden',
              borderRadius: 4,
              outline: '1px rgba(42, 54, 71, 0.08) solid',
              outlineOffset: '-1px',
              justifyContent: 'flex-start',
              alignItems: 'center',
              gap: 12,
              display: 'flex',
            }}
          >
            <div
              style={{
                color: '#2B323B',
                fontSize: 16,
                fontFamily: 'Inter',
                fontWeight: '400',
                wordWrap: 'break-word',
              }}
            >
              Compare by
            </div>
            <div style={{ width: 12, height: 7.33, background: '#2B323B' }} />
          </div>
        </div>
      </div>

      <Divider />

      {routeObjs.map((route, index) => (
        <div
          key={index}
          style={{
            width: '100%',
            padding: 16,
            background: 'white',
            borderRadius: 6,
            display: 'grid',
            gridTemplateColumns: 'repeat(6, 1fr)',
            gap: 16,
            marginTop: '6px',
            alignItems: 'center',
          }}
        >
          {/* Route Name Column */}
          <div style={{ gridColumn: '1 / 2', textAlign: 'left' }}>
            <div
              style={{
                justifyContent: 'start',
                color: 'rgba(0, 0, 0, 0.36)',
                fontSize: 16,
                fontFamily: 'Inter',
                fontWeight: '400',
              }}
            >
              Route Name
            </div>
            {route.routes.map((i, idx) => (
              <div
                key={idx}
                style={{
                  color: '#2B323B',
                  whiteSpace: 'nowrap',
                  maxWidth: '200px',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  fontSize: 16,
                  fontFamily: 'Inter',
                  fontWeight: '500',
                  marginTop: 8,
                }}
              >
                {i.routeName}
              </div>
            ))}
          </div>

          {/* Start Location Column */}
          <div style={{ gridColumn: '2 / 3', textAlign: 'left' }}>
            <div
              style={{
                justifyContent: 'start',
                color: 'rgba(0, 0, 0, 0.36)',
                fontSize: 16,
                fontFamily: 'Inter',
                fontWeight: '400',
              }}
            >
              Start Location
            </div>
            {route.routes.map((i, idx) => {
              // Split the start_location into latitude and longitude
              const [startLat, startLng] = i.start_location
                .split(',')
                .map((coord) => parseFloat(coord));
              // Split the end_location into latitude and longitude
              return (
                <div
                  key={idx}
                  style={{
                    color: '#2B323B',
                    fontSize: 16,
                    fontFamily: 'Inter',
                    fontWeight: '500',
                    marginTop: 8,
                  }}
                >
                  {/* Display formatted start location */}
                  {!isNaN(startLat) && !isNaN(startLng)
                    ? `(${startLat.toFixed(5)}, ${startLng.toFixed(5)})`
                    : '-'}
                </div>
              );
            })}
          </div>

          {/* End Location Column */}
          <div style={{ gridColumn: '3 / 4', textAlign: 'left' }}>
            <div
              style={{
                justifyContent: 'start',
                color: 'rgba(0, 0, 0, 0.36)',
                fontSize: 16,
                fontFamily: 'Inter',
                fontWeight: '400',
              }}
            >
              End Location
            </div>
            {route.routes.map((i, idx) => {
              // Split the start_location into latitude and longitude
              const [startLat, startLng] = i.end_location
                .split(',')
                .map((coord) => parseFloat(coord));
              // Split the end_location into latitude and longitude
              return (
                <div
                  key={idx}
                  style={{
                    color: '#2B323B',
                    fontSize: 16,
                    fontFamily: 'Inter',
                    fontWeight: '500',
                    marginTop: 8,
                  }}
                >
                  {/* Display formatted start location */}
                  {!isNaN(startLat) && !isNaN(startLng)
                    ? `(${startLat.toFixed(5)}, ${startLng.toFixed(5)})`
                    : '-'}
                </div>
              );
            })}
          </div>

          {/* Cost Column */}
          <div style={{ gridColumn: '4 / 5', textAlign: 'left' }}>
            <div
              style={{
                justifyContent: 'start',
                color: 'rgba(0, 0, 0, 0.36)',
                fontSize: 16,
                fontFamily: 'Inter',
                fontWeight: '400',
              }}
            >
              Cost
            </div>
            {route.routes.map((i, idx) => (
              <div
                key={idx}
                style={{
                  color: '#2B323B',
                  fontSize: 16,
                  fontFamily: 'Inter',
                  fontWeight: '500',
                  marginTop: 8,
                }}
              >
                {i.totalCost}
              </div>
            ))}
          </div>

          {/* Length Column */}
          <div style={{ gridColumn: '5 / 6', textAlign: 'left' }}>
            <div
              style={{
                justifyContent: 'start',
                color: 'rgba(0, 0, 0, 0.36)',
                fontSize: 16,
                fontFamily: 'Inter',
                fontWeight: '400',
              }}
            >
              Length
            </div>
            {route.routes.map((i, idx) => (
              <div
                key={idx}
                style={{
                  color: '#2B323B',
                  fontSize: 16,
                  fontFamily: 'Inter',
                  fontWeight: '500',
                  marginTop: 8,
                }}
              >
                {i.length}
              </div>
            ))}
          </div>

          {/* Compared Button Column */}
          {route.routes.length < 2 ? (
            <div style={{ gridColumn: '6 / 7', display: 'flex', justifyContent: 'flex-end' }}>
              <div
                style={{
                  width: 100,
                  height: 32,
                  padding: '6px 4px',
                  background: 'rgba(189, 29, 35, 0.24)',
                  boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
                  borderRadius: 4,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{
                    color: 'white',
                    cursor: 'pointer',
                    fontSize: 14,
                    fontFamily: 'Poppins',
                    fontWeight: '500',
                  }}
                >
                  Compared
                </div>
              </div>
            </div>
          ) : (
            <div style={{ gridColumn: '6 / 7', display: 'flex', justifyContent: 'flex-end' }}>
              <div
                style={{
                  width: 100,
                  height: 32,
                  padding: '6px 4px',
                  background: '#BD1D23',
                  boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
                  borderRadius: 4,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{
                    color: 'white',
                    cursor: 'pointer',
                    fontSize: 14,
                    fontFamily: 'Poppins',
                    fontWeight: '500',
                  }}
                >
                  Compared
                </div>
              </div>
            </div>
          )}
        </div>
      ))}
    </>
  );
}
